<script lang="ts">

    import { Modal, ModalBody, ModalFooter, ModalHeader, Icon, Label, Button, FormGroup } from "sveltestrap";
    import { kinshipsService } from "../services";
    import type { Third_Kinship } from "../Model/ThirdKinship"
    import ThirdNameInput from "./ThirdNameInput.svelte"
    import { createEventDispatcher } from "svelte"
    import AddThirdList from "./AddThirdList.svelte"
    import type { Kinship } from "../Model/Kinship"
    import AddKinshipModal from "./addKinshipModal.svelte"

    const dispatch = createEventDispatcher();
    
    export let kinship: Third_Kinship;

    let open = false;
    let size = 'lg';

    let kinshipParams: Kinship[];
    let changeThird = false;
    let createKinship = false;
    let third_relation = null;

    const toggle = () => {
	  size = 'lg';
	  open = !open;
	};

    let newKinship = null

    $: open = !!kinship;
     
    loadKinships();

    async function loadKinships() {
        kinshipParams = await kinshipsService.find();
    }

    async function changeThirdEvent(third){
    	kinship.third_relation = third.id;
    	changeThird = false;
    	dispatch("changeThirdLIst", third);
  	}

    async function saveKinship() {

        const response = await kinshipsService.saveKinship(kinship);

        if(response){
			open = false;
			dispatch("kinshipUpdate", kinship);
		}
    }

    async function deleteKinship(kinshipId) {
        if (!confirm('¿Esta seguro de querer eliminar esta relación?')) {
            return
        }

        const response = await kinshipsService.deleteKinship(kinshipId);

        if(response){
			open = false;
		}

        location.reload();
    }

    function getValues(type) {

        if (type == 'group') {
            let selectGroup = document.querySelector('#kinshipGroup');

            if(selectGroup.options[selectGroup.selectedIndex].id == '0') {
                let input = document.getElementById('inputGroup');
                input.hidden = false

            } else {
                let input = document.getElementById('inputGroup');
                input.hidden = true;
            }
        } else {
            let select = document.querySelector('#kinship');

            if(select.options[select.selectedIndex].id == '0') {
                let input = document.getElementById('input');
                input.hidden = false
                if(third_relation != null) {
                    kinship.third_relation = third_relation;
                }
            } else {
                let input = document.getElementById('input');
                input.hidden = true;
                third_relation = kinship.third_relation;
                kinship.third_relation = null;
            }
        }
        
    }

</script>



<Modal isOpen={open} {toggle} {size}>
    <ModalHeader {toggle}>Editar parentesco</ModalHeader>
    <ModalBody>
        {#if kinship.member}
                <FormGroup>
                    <Label for='kinship'>Relación</Label>
                    <div class="input-group">
                        <select bind:value={kinship.kinship} id='kinshipGroup' class='form-select' on:change={() => getValues('group')}>
                            {#each kinshipParams as param}
                                <option value={param.kinship} id={''+param.member}>{param.name}</option>
                            {/each}
                        </select>
                        <button
                            class="btn btn-secondary"
                            type="button"
                            on:click={() => {createKinship = true;}}
                        >
                            <Icon name="plus" />
                        </button>
                        
                    </div>
                    {#if createKinship}
                        <AddKinshipModal kinship={newKinship}/>
                    {/if}
                </FormGroup>
                
                
        
            <div hidden id='inputGroup'>
                <FormGroup>
                    <Label for='third'>Tercero relacionado</Label>
                    <div class="input-group">
                        <ThirdNameInput bind:id={kinship.third_relation} />
                        <button
                            class="btn btn-secondary"
                            type="button"
                            id="complainantThirId"
                            name="complainantThirId"
                            on:click={() => {changeThird = true;}}
                        >
                            <Icon name="plus" />
                        </button>
                    </div>
                    {#if changeThird}
                        <div class="m-3 p-2 border rounded third-box-modal">
                            <h5>Busqueda de Terceros</h5>
                            <AddThirdList on:changeThird={(event) => changeThirdEvent(event.detail)} />
                        </div>
                    {/if}
                </FormGroup>
            </div>
        {:else}
            <FormGroup>
                <Label for='kinship'>Relación</Label>
                <div class="input-group">
                    <select bind:value={kinship.kinship} id='kinship' class='form-select' on:change={() => getValues('input')}>
                        {#each kinshipParams as param}
                            <option value={param.kinship} id={''+param.member}>{param.name}</option>
                        {/each}
                    </select>
                    <button
                        class="btn btn-secondary"
                        type="button"
                        on:click={() => {newKinship = true;}}
                    >
                        <Icon name="plus" />
                    </button>
                    
                </div>
                {#if newKinship}
                    <AddKinshipModal kinship={newKinship} />
                {/if}
            </FormGroup>

            <div id='input'>
                <FormGroup>
                    <Label for='third'>Tercero relacionado</Label>
                    <div class="input-group">
                        <ThirdNameInput bind:id={kinship.third_relation} />
                        <button
                            class="btn btn-secondary"
                            type="button"
                            id="complainantThirId"
                            name="complainantThirId"
                            on:click={() => {changeThird = true;}}
                        >
                            <Icon name="plus" />
                        </button>
                    </div>
                    {#if changeThird}
                        <div class="m-3 p-2 border rounded third-box-modal">
                            <h5>Busqueda de Terceros</h5>
                            <AddThirdList on:changeThird={(event) => changeThirdEvent(event.detail)} />
                        </div>
                    {/if}
                </FormGroup>
            </div>
        {/if}
        
    
    </ModalBody>
    <ModalFooter>
        <Button color="danger" on:click={() => deleteKinship(kinship.id)}>Eliminar</Button>
        <Button color="primary" on:click={saveKinship}>Guardar</Button>
    </ModalFooter>
  </Modal>